module.exports = __webpack_public_path__ + "static/DINOT-Regular-0253ff1e7ce363ce77f48341977c7341.otf";